export default __webpack_public_path__ + "static/media/1.914706d8.jpg";